import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "email-items-header-container" }
const _hoisted_2 = { class: "button-container" }
const _hoisted_3 = { class: "group-content" }

import { PropType, ref, computed } from "vue";
import { ContextMenuItem } from '@/types/ui/menus/ContextMenuItem';
import GridBase from '@/components/ui/grid/grid-base.vue';
import { DxColumn } from 'devextreme-vue/data-grid';
import GridMenu from '@/components/ui/grid/grid-menu.vue';
import { EmailItem } from "@/types/emails/EmailItem";
import DxButton from 'devextreme-vue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'email-items',
  props: {
    /** 
     * The data source for the component, expected to be an array of EmailItem objects.
     * @type {EmailItem[]}
     * @required
     */
    dataSource: {
        type: Array as PropType<EmailItem[]>,
        required: true
    },
    /** 
     * The header for the group, used to categorize the email items.
     * @type {string}
     * @required
     */
    groupHeader: {
        type: String,
        required: true
    },
    /** 
     * The alias name associated with the group of email items.
     * @type {string}
     * @required
     */
    aliasName: {
        type: String,
        required: true
    }
},
  emits: ["row-selected", "rowClick", "menuItemClick", "onRowReorder"],
  setup(__props, { emit }) {

const props = __props;



const exportGrid = ref(false);
const loading = ref<false>();


const contextMenuId = computed(() => `${props.aliasName}-email-modal-email-items-list`);

const originalMenuItems = ref<ContextMenuItem[]>([
    { key: 'new', text: 'New', icon: 'fas fa-plus' },
    { key: 'edit', text: 'Edit', icon: 'fas fa-pencil' },
    { key: 'delete', text: 'Delete', icon: 'fas fa-trash' },
    { key: 'export', text: 'Export to Excel', icon: 'fas fa-download' },
    { key: 'refresh', text: 'Refresh', icon: 'fas fa-redo' },
]);

const menuItems = computed(() => {
    return originalMenuItems.value.map(item => ({
        ...item,
        key: `${props.aliasName}-${item.key}`
    }));
});

const handleRowSelected = (row: EmailItem) => {
    if (!row) return;

    emit("row-selected", row);
};

const handleRowClick = (row: EmailItem) => {
    if (!row) return;

    emit("rowClick", row);
};

const onMenuItemClicked = async (key: string) => {
    if (key.includes('export')) {
        exportGrid.value = true;
    } else {
        emit('menuItemClick', key);
    }
};

const descriptionWidth = computed(()=>{
    return screen.width <= 600 ? '100%':'300px';
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DxButton), {
          icon: "fas fa-plus",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('menuItemClick', `${props.aliasName}-new`)))
        }),
        _createVNode(GridMenu, {
          "menu-items": menuItems.value,
          onItemClicked: onMenuItemClicked,
          "button-icon": "fas fa-bars",
          id: contextMenuId.value
        }, null, 8, ["menu-items", "id"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(GridBase, {
        dataSource: __props.dataSource,
        "id-column-name": "marketingEmailItemId",
        loading: loading.value,
        "show-action-button": true,
        "column-auto-width": true,
        onRowSelected: handleRowSelected,
        onRowClick: handleRowClick,
        showSearchPanel: true,
        "run-export": exportGrid.value,
        "onUpdate:runExport": _cache[1] || (_cache[1] = ($event: any) => ((exportGrid).value = $event)),
        onOnRowReorder: _cache[2] || (_cache[2] = (e) => emit('onRowReorder', e)),
        allowReordering: true
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "marketingEmailItemId",
            caption: "MarketingEmailItemId",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "description",
            caption: "Description",
            width: descriptionWidth.value,
            "hiding-priority": 3
          }, null, 8, ["width"]),
          _createVNode(_unref(DxColumn), {
            "data-field": "url",
            caption: "URL",
            "hiding-priority": 2
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "displayOrder",
            caption: "Order",
            width: "175px",
            "hiding-priority": 1
          })
        ]),
        _: 1
      }, 8, ["dataSource", "loading", "run-export"])
    ])
  ], 64))
}
}

})